// dependencies
import { Map, List } from "immutable";
import { getParsedQuery } from "yarrr";

// selectors
import { getUI } from "Selectors/ui";

export const getRequests = (state) => getUI(state).get("requests", List());
export const getPageSize = (state) => getUI(state).get("pageSize", 1);
export const getCurrentPage = (state) => getUI(state).get("currentPage", 1);
export const getRequestsCount = (state) => getUI(state).get("requestsCount", 0);
export const getMethodOptions = (state) => getUI(state).get("methodOptions", List());
export const getPossessedOptions = (state) => getUI(state).get("possessedOptions", List());
export const getAuthenticatedOptions = (state) => getUI(state).get("authenticatedOptions", List());

// query params
export const getFiltersMap = (state) => {
	const parsedQuery = getParsedQuery(state);

	const { requestID = "", url = "", method = "", possessed = "", authenticated = "" } = parsedQuery;

	return Map({
		url,
		method,
		possessed,
		requestID,
		authenticated,
	});
};
